import styled from 'styled-components'

const OverflowContainer = styled.div`
  overflow-x: auto;
`

export default OverflowContainer

